module.exports = __webpack_public_path__ + "static/img-about-3af1bbd27fff01ab3894ace9cd455609.png";